import { Injectable } from '@angular/core';
import { GenericService } from '@messaia/cdk';
import { Country } from '../models/country';

@Injectable({ providedIn: 'root' })
export class CountryService extends GenericService<Country> {

	/**
	 * Constructor
	 */
	constructor() {
		super('country');
	}
}